/* istanbul ignore next */
export const DEVICE_TYPE_CONFIG = {
  tablet: 767,
  desktop: 959,
};
